//Supported field types for passenger form
export const DATE = 'date';
export const EMAIL = 'email';
export const TEXTAREA = 'textarea';
export const CHECKBOX = 'checkbox';
export const RADIOBUTTON = 'radiobutton';
export const NUMBER = 'number';
export const PHONE = 'phone';
export const TEXTBOX = 'textbox';
export const BOOLEAN = 'boolean';
export const FILE_UPLOAD = 'file_upload';
export const SIGNABLE_DOCUMENT = 'signabledocument';

// Special key to represent all add-ons as a group
export const ADDONS_GROUP_KEY = '__addons_group__';
export const PRICING_PLAN_KEY = '__pricing_plan__';
